export default {
  sidebar: {
    dashboard: 'Dashboard',
    prescriptions: 'Prescriptions',
    consultations: 'Consultations',
    appointments: 'Appointments',
    messages: 'Messages',
    medicalRecords: 'Medical Records',
    notifications: 'Notifications',
    settings: 'Settings',
    profile: 'Profile',
    security: 'Security',
    logout: 'Logout',
    adminPanel: 'Administration',
    doctors: 'Doctors',
    patientRecords: 'Patient Records',
    colleagues: 'Colleagues',
    users: 'Users',
    services: 'Services & Offers',
    financials: 'Financial Reports',
    moderation: 'Consultation Moderation',
    monitoring: 'System Monitoring',
    communications: 'Broadcast & Messages',
    permissions: 'Permissions & Roles',
    dataExport: 'Backup & Data Export',
    elitePlatform: 'Elite Platform',
    closeMenu: 'Close menu',
    mainMenu: 'Main menu',
    mainNavigation: 'Main navigation',
    healthLevel: 'Health Level',
    onlineCabinet: 'Online Cabinet',
    currentStatus: 'Current Status',
    healthRanks: {
      elite: 'Elite Patient',
      adept: 'Health Adept',
      initiate: 'Health Initiate'
    },
    offline: 'OFFLINE'
  },
  header: {
    search: 'Search...',
    notifications: 'Notifications',
    profile: 'My Profile',
    logout: 'Logout'
  },
  topbar: {
    openNavigation: 'Open navigation menu',
    onlinePractitioners_one: '{{count}} PRACTITIONER',
    onlinePractitioners_other: '{{count}} PRACTITIONERS',
    unreadMessages_one: '{{count}} unread message',
    unreadMessages_other: '{{count}} unread messages',
    unreadNotifications_one: '{{count}} medical alert',
    unreadNotifications_other: '{{count}} medical alerts'
  },
  userMenu: {
    title: 'User menu',
    open: 'Open user menu',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout'
  },
  dashboardSidebar: {
    messages: 'Messages',
    notifications: 'Notifications',
    onlineUsers: 'Online Users',
    alerts: 'Alerts',
    online: 'Online',
    close: 'Close'
  },
  languages: {
    fr: 'Français',
    en: 'English'
  },
  presence: {
    title: 'Online users',
    loading: 'Loading...',
    retry: 'Retry',
    teamOnline: 'Team online',
    memberCount_one: '{{count}} Member',
    memberCount_other: '{{count}} Members',
    refresh: 'Refresh',
    noUsers: 'No users online',
    rolePractitioner: 'Practitioner',
    rolePatient: 'Patient',
    lastSeenJustNow: 'Just now',
    lastSeenMins: '{{count}}m ago',
    lastSeenHours: '{{count}}h ago',
    lastSeenUnknown: 'Unknown',
    defaultDoctorName: 'Doctor',
    defaultPatientName: 'Patient',
    availableDoctors: 'Available Doctors ({{count}})',
    noDoctorsAvailable: 'No doctors available',
    onlinePatients: 'Online Patients ({{count}})',
    noPatientsOnline: 'No patients online',
    statusOnline: 'Online'
  },
  feedback: {
    error: 'Error during navigation to {{target}}',
    home: 'Home',
    close: 'Close',
    navigating: 'Navigating',
    back: 'Back',
    refresh: 'Refresh'
  }
};
